export type Some<T> = { ok: true; value: T };
export type None = { ok: false };
export type Option<T> = Some<T> | None;

export const Some = <T>(value: T): Option<T> => ({ ok: true, value });
export const None = <T>(): Option<T> => ({ ok: false });
